import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { NgbActiveModal } from '../../../../node_modules/@ng-bootstrap/ng-bootstrap';
import { RiskEvent } from "../../_interfaces/RiskEvent.model";
import { RepositoryService } from "../../shared/services/repository.service";

@Component({
  selector: 'app-risk-event-editor',
  templateUrl: './risk-event-editor.component.html',
  styleUrls: ['./risk-event-editor.component.css']
})
export class RiskEventEditorComponent implements OnInit {
  riskEvent: RiskEvent = new RiskEvent();
  eventForm: FormGroup;
  riskId: string;
  riskType: string;

  @Input() my_modal_title;
  @Output() messageToEmit = new EventEmitter<string>();

  constructor(private repository: RepositoryService, public activeModal: NgbActiveModal) { }

  ngOnInit() {
    this.my_modal_title = 'Add New Risk Event';

    this.eventForm = new FormGroup({
      name: new FormControl(''),
      description: new FormControl(''),
      actionsTaken: new FormControl(''),
      cost: new FormControl(''),
      estimatedLiability: new FormControl(''),
      riskType: new FormControl(this.riskType),
      relatedRisk: new FormControl(this.riskId),
    //status: new FormControl(''),
      //mitigation: new FormControl(''), 
      // 
      //controlEffectiveness: new FormControl(''),
      //probabilityReduction: new FormControl(''),
      //keyStatus: new FormControl(''),
      //reviewAndUpdateDate: new FormControl(''),
      //costBased: new FormControl(''),
      //costReduction: new FormControl(''),

    });
  }
  onSubmit() {
   // console.warn(this.eventForm.value);
    this.riskEvent.riskId = +this.riskId;
    this.riskEvent.name = this.f.name.value;
    this.riskEvent.description = this.f.description.value;
    this.riskEvent.cost = this.f.cost.value;
    this.riskEvent.estimatedLiability = this.f.estimatedLiability.value;
    this.riskEvent.actionsTaken = this.f.actionsTaken.value;
    this.riskEvent.status = 1; // New
    //  Post the new Risk Event to Web Api
    let apiAddress: string = `RiskEvents`;
    this.repository.create(apiAddress, this.riskEvent)
      .subscribe(res => {
        console.log(res);
        //alert('Risk Event Added !!');
        this.messageToEmit.emit(`refresh`);
        this.activeModal.close('Submit click');
        // return res;
      });


  }

  // convenience getter for easy access to form fields
  get f() { return this.eventForm.controls; }
}
